import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as EmotionThemeProvider, useTheme, } from "@emotion/react";
import { theme } from "./theme";
export const ThemeConsumer = ({ children }) => {
    return children(useTheme());
};
export const ThemeProvider = ({ children }) => (_jsx(EmotionThemeProvider, { theme: theme, children: children }));
